import axios from "axios";

const instance = axios.create({
  // baseURL: "http://localhost:8080",
  // baseURL: "https://shreemanglamshikshansansthan.onrender.com",
  baseURL: "https://shreemangalamschool.com",
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
}); 

export default instance;